export var tabletDetailsWidth = '297.5px';
export var desktopDetailsWidth = '100%';
export var desktopDetailsHeight = '148px';
export var priceFontSize = '18px';
export var fullImageWidth = '198px';
export var fullImageHeight = '148px';
export var fullScreenWidth = '498.5px';
export var fullScreenHeight = '150px';